import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const CategoryContext = createContext();

export function CategoryProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCategories = useCallback(async () => {
    try {
      const response = await api.get('/public/category-settings');
      setCategories(response.data || []);
    } catch (error) {
      console.error('카테고리 로드 실패:', error);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  // 활성 카테고리 (핫딜 포함)
  const activeCategories = categories.filter(cat => cat.active !== false);

  // 핫딜 제외 (상품 등록용)
  const adminCategories = activeCategories.filter(cat => !cat.isHot);

  // 카테고리 value로 찾기
  const getCategoryByValue = useCallback((value) => {
    return categories.find(cat => cat.categoryValue === value);
  }, [categories]);

  // 카테고리 name 찾기
  const getCategoryName = useCallback((value) => {
    const cat = getCategoryByValue(value);
    return cat ? (cat.name || cat.title) : value;
  }, [getCategoryByValue]);

  // 카테고리 prefix 찾기 (상품코드 채번용)
  const getCategoryPrefix = useCallback((value) => {
    const cat = getCategoryByValue(value);
    return cat ? cat.prefix : 'GEN';
  }, [getCategoryByValue]);

  return (
    <CategoryContext.Provider value={{
      categories: activeCategories,
      adminCategories,
      allCategories: categories,
      loading,
      getCategoryByValue,
      getCategoryName,
      getCategoryPrefix,
      refreshCategories: fetchCategories,
    }}>
      {children}
    </CategoryContext.Provider>
  );
}

export function useCategories() {
  const context = useContext(CategoryContext);
  if (!context) {
    throw new Error('useCategories must be used within a CategoryProvider');
  }
  return context;
}
